export default __webpack_public_path__ + "static/media/CallUs@4x.1dc58cbc.png";